
const messages = {
    en: {
       maps: {
          locality: { 
            name: 'Locality',
            title: 'Locality management',
            subtitle: 'View, search, create, edit and delete Locality',
            creating: 'Creating Locality',
            editing: 'Editing Locality',
            deleting: 'Deleting Locality',
            showing: 'Showing Locality',
            menu: 'Locality',
            labels: {
                locality: 'Locality'
            },
          
          }
       }
    },
    es: {
       maps: {
          locality: { 
            name: 'Locality',
            title: 'Administración de Locality',
            subtitle: 'Ver, buscar, crear, editar, y borrar Locality',
            creating: 'Creando Locality',
            editing: 'Modificando Locality',
            deleting: 'Eliminando Locality',
            showing: 'Detalles de Locality',
            menu: 'Locality',
            labels: {
                locality: 'Localidad'
            },
          
          }
       }
    },
    pt: {
       maps: {
          locality: { 
            name: 'Locality',
            title: 'Administração de Locality',
            subtitle: 'Ver, buscar, criar, editar e usar Locality',
            creating: 'Criando Locality',
            editing: 'Edição Locality',
            deleting: 'Apagando Locality',
            showing: 'Detalhes do Locality',
            menu: 'Locality',
            labels: {
                locality: 'Localidade'
            },
          
          }
       }
    }
}

export default messages
    